<script setup lang="ts">
import HeroSection from '@/pages/HomePage/HomeHero.vue';
import IconsSection from '@/pages/HomePage/HomeIcons.vue';
import HelpSection from '@/pages/HomePage/HomeHelp.vue';
import CuratedSection from '@/pages/HomePage/HomeCurated.vue';
import CharterSection from '@/pages/HomePage/HomeCharter.vue';
import WhyChooseSection from '@/pages/HomePage/HomeWhyChoose.vue';
import TestimonialsSection from '@/pages/HomePage/Testimonials/HomeTestimonials.vue';
import PageList from "@/components/Pages/PageList.vue";
import { usePageSEO } from '@/composables/usePageSEO'
import ItineraryList from "@/components/Itineraries/ItineraryList.vue";

import PromotionSection from "@/pages/HomePage/HomePromotion.vue";
// import YachtsSection from "@/pages/HomePage/HomeYachts.vue";


usePageSEO('')
</script>

<template>

  <HeroSection />
  <CuratedSection />
  <CharterSection />
<!--  <YachtsSection />-->
  <PromotionSection />
  <div class="container pt-24 travel-inspirations">
    <ItineraryList slug="travel-inspiration"/>
  </div>
  <TestimonialsSection />
  <div class="container pt-24 travel-inspirations">
    <PageList slug="travel-inspiration"/>
  </div>
  <IconsSection />

</template>